// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__BUewk","info":"PatientInfo_info__KgGUp"};